import { Icon, SvgVideoLibrary } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function PipButton(props) {
  return (
    <ControlBarButton
      className={classNames('video-player-pip-button', {
        'crowded-embed': props.crowded,
      })}
      hoverTagText="Toggle PIP (p)"
      seeking={props.seeking}
      onClick={props.onClick}
      inTrimMode={props.inTrimMode}
    >
      <Icon
        className="control-bar-button-icon"
        color={props.inTrimMode ? 'disabledContent' : 'white'}
        icon={<SvgVideoLibrary />}
      />
    </ControlBarButton>
  );
}
